<div *ngIf="statuses" class="fund-filtering">
	<dz-toggle-switch
		[toggleLabel]="'Select Fund Status To Include' | dcr: 'IQ_GENERATE_REPORT_FILTER_TITLE'"
		[dcrKeys]="['IQ_GENERATE_REPORT_FILTER_TITLE']"
		(click)="onToggleChange()"
	>
	</dz-toggle-switch>

	<div class="checkbox-container" *ngIf="isToggleExpanded">
		<ng-container *ngFor="let item of statuses; let i = index">
			<dz-checkbox (change)="onCheckBoxClick(item.statusId)" [disabled]="false" [checked]="true"
				><icon type="circle" class="icon {{ item.statusId }}"></icon>{{ item?.description }}</dz-checkbox
			>
		</ng-container>
	</div>
</div>
